import React from 'react'
import { Col, Nav, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap'
import { Route, useNavigate } from 'react-router-dom'
import { Routes } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { BsFillGrid3X3GapFill } from "react-icons/bs";
import Cookies from 'js-cookie'
import { BiLogOut } from 'react-icons/bi'
import { Users } from './Tabs/Users/Users'
import { FaUsers } from 'react-icons/fa'
import { IoCalendar, IoSettingsOutline } from "react-icons/io5";
import { Config } from './Tabs/Config/Config'
import { Buttons } from './Tabs/Buttons/Buttons'
import { useTestAdminToken } from '../../pages/Dashboard/Hooks/useTestAdminToken'
import { MdHistory } from 'react-icons/md'
import { History } from './Tabs/History/History'
import { Players } from './Tabs/Players/Players'
import GestorIcon from '../../assets/GestorIcon'
import { Preferences } from './Tabs/Preferences/Preferences'
import { Promotions } from './Tabs/Promotions/Promotions'
import { FiGift } from 'react-icons/fi'
import { ProtectedRouteGestorAdmin } from '../../ProtectedRoutes/ProtectedRouteGestorAdmin'
import { Calendar } from './Tabs/Calendar/Calendar'
import { UserSessions } from './Tabs/UserSessions/UserSessions'

export const DashboardAdmin = () => {
    const { loadingConnection, adminInfo, testToken } = useTestAdminToken()
    const navigate = useNavigate();

    const hasGestorURL = !!adminInfo?.gestorUrl

    const renderNavLink = ({ to, icon, text, isMobile }: { to: string, icon: any, text: string, isMobile: boolean }) => {
        const link = (
            <Nav.Link
                as={Link}
                to={to}
                className={`d-flex align-items-center justify-content-center gap-3 px-2 py-3 text-secondary hover-primary`}
            >
                {React.cloneElement(icon, { size: 24 })}
            </Nav.Link>
        );

        return (
            <OverlayTrigger
                placement={isMobile ? "bottom" : "top"}
                overlay={<Tooltip>{text}</Tooltip>}
            >
                {link}
            </OverlayTrigger>
        )
    };


    const renderLogoutButton = ({ icon, text, isMobile }: { icon: any, text: string, isMobile: boolean }) => {
        const link = (
            <Nav.Link

                onClick={() => {
                    Cookies.remove('Token')
                    Cookies.remove('loggedAs')
                    navigate('/login')
                }}
                className={`d-flex align-items-center justify-content-center gap-3 px-2 py-3 text-secondary hover-primary`}
            >

                {React.cloneElement(icon, { size: 24 })}
            </Nav.Link>
        );

        return (
            <OverlayTrigger
                placement={isMobile ? "bottom" : "top"}
                overlay={<Tooltip>{text}</Tooltip>}
            >
                {link}
            </OverlayTrigger>
        )
    }

    if (loadingConnection) {
        return <div className='d-flex justify-content-center align-items-center vh-100'>
            <Spinner animation="border" variant="primary" />
        </div>
    }


    // if (!connected) {
    //     return <div>No estás conectado a la plataforma</div>
    // }


    return (
        <div>
            <div className="position-relative">


                <Row className='d-flex justify-content-center mt-0 d-md-none mt-md-3'>
                    <div className='w-100 mb-2 text-xs text-secondary text-primary d-flex align-items-center justify-content-center gap-2 mt-2'>
                        {adminInfo?.name} <span className='text-xs text-warning'> (Administrador)</span>
                    </div>
                    <Nav className="flex-row justify-content-around align-items-center shadow" style={{ fontSize: '16px' }}>
                        {renderNavLink({ to: "/admin/dashboard/users", icon: <FaUsers />, text: "Usuarios", isMobile: true })}
                        {renderNavLink({ to: "/admin/dashboard/buttons", icon: <BsFillGrid3X3GapFill />, text: "Botones", isMobile: true })}
                        {hasGestorURL && renderNavLink({ to: "/admin/dashboard/promotions", icon: <FiGift />, text: "Promociones", isMobile: true })}
                        {renderNavLink({ to: "/admin/dashboard/history", icon: <MdHistory />, text: "Historial", isMobile: true })}
                        {renderNavLink({ to: "/admin/dashboard/user-sessions", icon: <IoCalendar />, text: "Sesiones de Usuarios", isMobile: true })}
                        {hasGestorURL && renderNavLink({
                            to: "/admin/dashboard/preferences",
                            icon: <div className='d-flex align-items-center justify-content-center  text-secondary hover-primary'>
                                <GestorIcon color='currentColor' size={28} />
                            </div>,
                            text: "Gestor",
                            isMobile: true
                        })}
                        {renderNavLink({ to: "/admin/dashboard/settings", icon: <IoSettingsOutline />, text: "Configuración", isMobile: true })}
                        <div className="mt-auto">
                            {renderLogoutButton({ icon: <BiLogOut />, text: "Cerrar Sesión", isMobile: true })}
                        </div>

                    </Nav>

                    <hr />
                </Row>


                <Row>
                    <Col
                        style={{
                            maxWidth: '100px',
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            height: '100vh',
                            zIndex: 1000
                        }}
                        className="d-none d-md-block bg-white shadow-md"
                    >
                        <div className='text-center text-xs text-secondary mt-3 text-primary'>
                            <div className='text-xs text-warning'>
                                Admin
                            </div>
                            {adminInfo?.name?.substring(0, 6)}{adminInfo?.name && adminInfo?.name?.length > 6 ? '...' : ''}
                            <br />
                        </div>
                        <Nav className="flex-column m-3 d-flex flex-column justify-content-between" style={{ fontSize: '16px' }}>
                            <div className="mt-4">
                                <div>
                                    {renderNavLink({ to: "/admin/dashboard/users", icon: <FaUsers />, text: "Usuarios", isMobile: false })}
                                    {renderNavLink({ to: "/admin/dashboard/buttons", icon: <BsFillGrid3X3GapFill />, text: "Botones", isMobile: false })}
                                    {hasGestorURL && renderNavLink({ to: "/admin/dashboard/promotions", icon: <FiGift />, text: "Promociones", isMobile: false })}
                                    {/* {renderNavLink({ to: "/admin/dashboard/calendar", icon: <IoCalendar />, text: "Calendario de Disponibilidad", isMobile: false })} */}
                                    {renderNavLink({ to: "/admin/dashboard/user-sessions", icon: <IoCalendar />, text: "Sesiones de Usuarios", isMobile: false })}

                                    {renderNavLink({ to: "/admin/dashboard/history", icon: <MdHistory />, text: "Historial", isMobile: false })}
                                    {hasGestorURL && renderNavLink({
                                        to: "/admin/dashboard/preferences",
                                        icon: <div className='d-flex align-items-center justify-content-center  text-secondary hover-primary'>
                                            <GestorIcon color='currentColor' size={28} />
                                        </div>,
                                        text: "Gestor",
                                        isMobile: false
                                    })}
                                    {renderNavLink({ to: "/admin/dashboard/settings", icon: <IoSettingsOutline />, text: "Configuración", isMobile: false })}

                                    <div className='mt-5'>
                                        {renderLogoutButton({ icon: <BiLogOut />, text: "Cerrar Sesión", isMobile: false })}
                                    </div>
                                </div>
                            </div>
                        </Nav>
                    </Col>



                    <Col md={2}
                        className="d-none d-md-block bg-white shadow-md"
                        style={{
                            width: '100px',
                            minWidth: '100px'
                        }}></Col>


                    <Col style={{
                        height: '100vh',
                        overflowY: 'auto',
                    }}
                        className="px-4 pt-0 pt-md-3 px-md-5"
                    >
                        <Routes>
                            <Route path="/" element={<Users />} />
                            <Route path="/settings" element={<Config adminInfo={adminInfo} testToken={testToken} />} />
                            <Route path="/users" element={<Users />} />
                            <Route path="/buttons" element={<Buttons adminInfo={adminInfo} />} />
                            <Route path="/history" element={<History />} />
                            <Route path="/user-sessions" element={<UserSessions />} />

                            <Route path="/players" element={<ProtectedRouteGestorAdmin element={<Players />} hasGestorURL={hasGestorURL} />} />
                            <Route path="/preferences" element={<ProtectedRouteGestorAdmin element={<Preferences />} hasGestorURL={hasGestorURL} />} />
                            <Route path="/promotions" element={<ProtectedRouteGestorAdmin element={<Promotions />} hasGestorURL={hasGestorURL} />} />
                            {/* <Route path="/calendar" element={<ProtectedRouteGestorAdmin element={<Calendar />} hasGestorURL={hasGestorURL} />} /> */}
                        </Routes>
                    </Col>
                </Row>
            </div >
        </div >
    )
}
